export interface FaqAnchorRegistry {
    /** Returns the first page url when `routeHash` was already claimed on a different one, once per routeHash. */
    claim: (routeHash: string, pageUrl: string) => string | undefined
}

export function createFaqAnchorRegistry(): FaqAnchorRegistry {
    const firstPageUrls = new Map<string, string>()
    const reported = new Set<string>()

    function claim(routeHash: string, pageUrl: string): string | undefined {
        const firstPageUrl = firstPageUrls.get(routeHash)

        if (firstPageUrl === undefined) {
            firstPageUrls.set(routeHash, pageUrl)
            return undefined
        }

        if (firstPageUrl === pageUrl || reported.has(routeHash)) return undefined

        reported.add(routeHash)
        return firstPageUrl
    }

    return { claim }
}
